// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Temp fonts
  fonts: {
    title: 'Roboto, sans-serif',
    main: 'Roboto, sans-serif'
  },
  // Colors for layout
  colors: {
    background: '#0F1525',
    textColor: '#e2e2e2',
    darkPurple: '#110042',
    lightPurple: '#340670',
    lightPurple2: '#610094',
    greenText: '#15EC1D',
    orangeText: '#CF9A10',
    hoverTech: '#19BBF3',
  },
  // Breakpoints for responsive design
  breakpoints: {
    xsm: 'screen and (min-width: 320px)',
    sm: 'screen and (min-width: 640px)',
    md: 'screen and (min-width: 768px)',
    lg: 'screen and (min-width: 1024px)',
    xl: 'screen and (min-width: 1280px)'
  },
}